var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9C13.4087 9 11.8826 9.63214 10.7574 10.7574C9.63214 11.8826 9 13.4087 9 15",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.933 6C17.6155 7.2714 17.956 8.69834 17.9209 10.1409C17.8858 11.5835 17.4765 12.9923 16.733 14.229C15.9887 15.4685 14.9367 16.4947 13.6791 17.208C12.4215 17.9213 11.0008 18.2974 9.555 18.3C8.32775 18.3062 7.11413 18.0427 6 17.528C6.28443 19.3883 7.08514 21.1315 8.31108 22.5594C9.53702 23.9872 11.139 25.0425 12.9349 25.6051C14.7308 26.1677 16.6485 26.2151 18.47 25.742C20.2915 25.2688 21.9436 24.2941 23.2387 22.9286C24.5337 21.5631 25.4196 19.8616 25.7956 18.0176C26.1717 16.1736 26.0228 14.2611 25.3659 12.4975C24.709 10.734 23.5704 9.19009 22.0797 8.04146C20.5889 6.89284 18.8058 6.18554 16.933 6Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsDarkMode);
export default __webpack_public_path__ + "static/media/settings-dark-mode.ec5870a64554bb1eb06d0a927e15cc91.svg";
export { ForwardRef as ReactComponent };